import { render } from "./BeginnerEssayArea.vue?vue&type=template&id=644fabbd&scoped=true"
import script from "./BeginnerEssayArea.vue?vue&type=script&lang=js"
export * from "./BeginnerEssayArea.vue?vue&type=script&lang=js"

import "./BeginnerEssayArea.vue?vue&type=style&index=0&id=644fabbd&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=644fabbd&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644fabbd"]])

export default __exports__